import './App.css';
import {  Routes, useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import {  Route } from 'react-router-dom';
import Auth from "./pages/Auth/Auth";
import './assets/css/cleanMinimalTable.css';
import './assets/css/module-ui.css';
import './assets/css/sims-ui.css';

import NavbarMobile from "./components/Navbar/NavbarAdmin/NavbarMobile";
import NavbarDekstop from "./components/Navbar/NavbarAdmin/NavbarDekstop";
import { useMediaQuery } from 'react-responsive'
import Sidebar from "./components/Sidebar/SidebarHome";
import Dashboard from "./pages/Dashboard/Home";

// Master Data
import MasterDaftarPengguna from "./pages/DaftarPengguna/Home";
import MasterKaryawan from "./pages/categories/superadmin/master_data/karyawan/Home";
import MasterGuru from "./pages/categories/siakad/lms/data_guru/Home";
import MasterPendaftaran from "./pages/categories/superadmin/master_data/pendaftaran/Home";
import MasterDept from "./pages/categories/superadmin/master_data/departemen/Home";
import MasterLantai from "./pages/categories/superadmin/master_data/lantai/Home";
import MasterCheckpoint from "./pages/categories/superadmin/master_data/checkpoint/Home";
import MasterImportSiswaBaru from "./pages/categories/superadmin/master_data/import_siswa_baru/Home";


// Privilege
import AdminSetups from "./pages/categories/superadmin/privilege/setup/Home";
import AdminApps from "./pages/categories/superadmin/privilege/kategori/Home";
import AdminAppsModule from "./pages/categories/superadmin/privilege/integrasi_module/Home";
import AdminModuleMenus from "./pages/categories/superadmin/privilege/integrasi_menu/Home";
import AdminMenus from "./pages/ListMenu/Home";
import AdminRoles from "./pages/ListRole/Home";
import AdminRolePermision from "./pages/ListRolePermission/Home";
import AdminModules from "./pages/ListModule/Home";
import AdminSubModules from "./pages/ListSubModule/Home";
import AdminUsers from "./pages/ListUser/Home";
import AdminUserPermission from "./pages/ListUserPermission/Home";
import AdminChangePassword from "./pages/ListChangePassword/Home";

// On Dev
import PageOnDev from "./pages/PageOnDev/PageOnDev";

// Not Found Page
import My404Component from "./pages/NotFoundPage/PageNotFound";

// QR Patrol
import BerandaPatrol from "./pages/categories/operational/qr_patrol/beranda/Home";
import CheckPoint from "./pages/categories/operational/qr_patrol/titik_pemeriksaan/Home";
import InspectionNotes from "./pages/categories/operational/qr_patrol/catatan_pemeriksaan/Home";

// LMS atau SIAKAD
import DataCabang from "./pages/categories/siakad/lms/data_cabang/Home";
import DataSekolah from "./pages/categories/siakad/lms/data_sekolah/Home";
import DataJenjang from "./pages/categories/siakad/lms/data_jenjang/Home";
import DataMurid from "./pages/categories/siakad/lms/data_murid/Home";
import DataKelas from "./pages/categories/siakad/lms/data_kelas/Home";
import ConfigKelas from "./pages/categories/siakad/lms/data_kelas/ConfigKelas";
import DataSemester from "./pages/categories/siakad/lms/data_semester/Home";
import DataTingkatan from "./pages/categories/siakad/lms/data_tingkatan/Home";
import DataTahunAjaran from "./pages/categories/siakad/lms/data_tahun_ajaran/Home";
import DataMatpel from "./pages/categories/siakad/lms/data_matpel/Home";
import DataEkskul from "./pages/categories/siakad/lms/data_ekskul/Home";
import PredikatEkskul from "./pages/categories/siakad/lms/data_ekskul/Predikat";
import ConfigEkskul from "./pages/categories/siakad/lms/data_ekskul/ConfigEkskul";
import EkskulGuru from "./pages/categories/siakad/lms/data_ekskul_guru/Home";
import DataKalender from "./pages/categories/siakad/lms/data_kalender/Home";
import DataEvent from "./pages/categories/siakad/lms/data_event/Home";
import Absensi from "./pages/categories/siakad/lms/data_absensi/Home";
import AbsensiAdmin from "./pages/categories/siakad/lms/data_absensi/HomeAdmin";
import AbsenDashboardTeacher from "./pages/categories/siakad/lms/dashboards_absensi/HomeTeacher";
import AbsenDashboardHead from "./pages/categories/siakad/lms/dashboards_absensi/HomeHead";
import AbsenDashboard from "./pages/categories/siakad/lms/dashboards_absensi/Home";
import TipeUjian from "./pages/categories/siakad/lms/data_matpel/TipeUjian";
import Fase from "./pages/categories/siakad/lms/data_matpel/Fase";
import FaseGrade from "./pages/categories/siakad/lms/data_matpel/configGradeFase";
import ConfigMatpel from "./pages/categories/siakad/lms/data_matpel/configMatpel";
import MatpelGuruYes from "./pages/categories/siakad/lms/data_matpel_guru/Homeyes";
import BukuNilai from "./pages/categories/siakad/lms/data_buku_nilai/Home";
import BukuNilaiTeacher from "./pages/categories/siakad/lms/data_buku_nilai/HomeTeacher";
import TranskipNilai from "./pages/categories/siakad/lms/data_transkip_nilai/Home";
import TranskipNilaiTeacher from "./pages/categories/siakad/lms/data_transkip_nilai/HomeTeacher";
import KegiatanKokurikuler from "./pages/categories/siakad/lms/data_matpel/Kegiatan";
import LegerSiakad from "./pages/categories/siakad/lms/leger/Home";
import TypeLeger from "./pages/categories/siakad/lms/leger/TypeLeger";
import AturBobot from "./pages/categories/siakad/lms/leger/AturBobot";
import LegerSiakadTeacher from "./pages/categories/siakad/lms/leger/HomeTeacher";
import WaliKelas from "./pages/categories/siakad/lms/data_walas/Home";
import WaliKelasSingle from "./pages/categories/siakad/lms/data_walas/HomeSingle";
import Rombel from "./pages/categories/siakad/lms/data_rombel/Home";
import ConfigSiswaBaru from "./pages/categories/siakad/lms/data_murid/HomeConfig";
import RaporSiakad from './pages/categories/siakad/lms/rapor/Home';
import RaporSiakadTeacher from './pages/categories/siakad/lms/rapor/HomeTeacher';
import KategoriKomentarSiakad from './pages/categories/siakad/lms/rapor/KomentarRapor';

// Laporan Adab
import MasterElements from "./pages/categories/siakad/laporan_adab/elements/Home";
import MasterSubElements from "./pages/categories/siakad/laporan_adab/sub_element/Home";
import MasterKKCA from "./pages/categories/siakad/laporan_adab/kkca/Home";
import MasterDimensi from "./pages/categories/siakad/laporan_adab/master_dimensi/Home";
import BerandaLA from "./pages/categories/siakad/laporan_adab/beranda/Home";
import IdentitasMurid from "./pages/categories/siakad/laporan_adab/identitas_sekolah/Home";
import Penilaian from "./pages/categories/siakad/laporan_adab/penilaian/Home";
import PenilaianHead from "./pages/categories/siakad/laporan_adab/penilaian/HomeHead";
import PenilaianHeadNew from "./pages/categories/siakad/laporan_adab/penilaian/HomeHeadNew";
import PenilaianHeadSuper from "./pages/categories/siakad/laporan_adab/penilaian/HomeHeadSuper";
import PenilaianHeadSuperNew from "./pages/categories/siakad/laporan_adab/penilaian/HomeHeadSuperNew";
import PenilaianTeacher from "./pages/categories/siakad/laporan_adab/penilaian/HomeTeacher";
import Leger from "./pages/categories/siakad/laporan_adab/leger/Home";
import LegerSync from "./pages/categories/siakad/laporan_adab/leger_sync/Home";
import LegerHead from "./pages/categories/siakad/laporan_adab/leger/HomeHead";
import LegerSyncHead from "./pages/categories/siakad/laporan_adab/leger_sync/HomeHead";
import LegerTeacher from "./pages/categories/siakad/laporan_adab/leger/HomeTeacher";
import LegerSyncTeacher from "./pages/categories/siakad/laporan_adab/leger_sync/HomeTeacher";
import Rapor from "./pages/categories/siakad/laporan_adab/rapor/Home";
import RaporSync from "./pages/categories/siakad/laporan_adab/rapor_sync/Home";
import RaporHead from "./pages/categories/siakad/laporan_adab/rapor/HomeHead";
import RaporHeadSync from "./pages/categories/siakad/laporan_adab/rapor_sync/HomeHead";
import RaporTeacher from "./pages/categories/siakad/laporan_adab/rapor/HomeTeacher";
import RaporTeacherSync from "./pages/categories/siakad/laporan_adab/rapor_sync/HomeTeacher";
import PengaturanDimensi from "./pages/categories/siakad/laporan_adab/pengaturan_dimensi/Home";
import PengaturanDimensiHead from "./pages/categories/siakad/laporan_adab/pengaturan_dimensi/HomeHead";
import PengaturanDimensiHeadNew from "./pages/categories/siakad/laporan_adab/pengaturan_dimensi/HomeHeadNew";
import PengaturanDimensiConfig from "./pages/categories/siakad/laporan_adab/pengaturan_dimensi/HomeConfigDimensi";
import DashboardTeacher from "./pages/categories/siakad/laporan_adab/beranda/HomeTeacher";
import DashboardHead from "./pages/categories/siakad/laporan_adab/beranda/HomeHead";
import DashboardSuper from "./pages/categories/siakad/laporan_adab/beranda/HomeSuper";
import KonfigurasiAngket from "./pages/categories/siakad/laporan_adab/konfigurasi-angket/Home";
import ConfigRekan from "./pages/categories/siakad/laporan_adab/konfigurasi-angket/subpage/ConfigRekan";
import KonfigurasiAngketTeacher from "./pages/categories/siakad/laporan_adab/konfigurasi-angket/HomeTeacher";
import PeerTeacher from "./pages/categories/siakad/laporan_adab/konfigurasi-angket/subpage/ConfigPeerTeacher";
import KonfigurasiAuth from "./pages/categories/siakad/laporan_adab/konfigurasi-angket/subpage/configAuth";
import KonfigurasiAuthTeacher from "./pages/categories/siakad/laporan_adab/konfigurasi-angket/subpage/ConfigAuthTeacher";
import PenilaianKaryawan from "./pages/categories/siakad/laporan_adab/penilaian_karyawan/Home";
import ListPrilaku from "./pages/categories/siakad/laporan_adab/list_prilaku/Home";
import KategoriPenilai from "./pages/categories/siakad/laporan_adab/kategori_penilai/Home";
import Pendaftaran from './components/categories/superadmin/master_data/pendaftaran/Home';

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem("token");
      const expiry = localStorage.getItem("token_expiry");

      if (!token || !expiry || new Date().getTime() > expiry) {
        localStorage.clear();
        navigate("/"); 
      }
    };

    checkToken();
    const interval = setInterval(() => {
      checkToken();
    }, 3600000);

    return () => clearInterval(interval);
  }, [navigate]);


  const pathName = window.location.pathname
  const arr = pathName.toString().split("/");
  const currentPath = arr[arr.length-1];

return (
  <>
  <div>
    { currentPath.length > 0 && <Layout />}
    <div className="main_content">
      <Routes>
          <Route path={'/'} element={<Auth />} />
      </Routes>
    </div>
  </div>
     
  </>        
 
  );
}


function Content() {
  return (
  <>
  <Routes>
    <Route exact path="/dashboard" element={<Dashboard />}/>
    
    {/* Master */}
    <Route exact path="/users" element={<MasterDaftarPengguna/>}/>
    <Route exact path="/employes" element={<MasterKaryawan/>}/>
    <Route exact path="/teachers" element={<MasterGuru/>}/>
    <Route exact path="/import-siswa-baru" element={<MasterImportSiswaBaru/>}/>
    <Route exact path="/departments" element={<MasterDept/>}/>
    <Route exact path="/rooms" element={<MasterCheckpoint/>}/>
    <Route exact path="/floors" element={<MasterLantai/>}/>
    <Route exact path="/pendaftaran" element={<MasterPendaftaran/>}/>
    
    {/* Privilege */}
    <Route exact path="/privileges/setups" element={<AdminSetups/>} />
    <Route exact path="/privileges/apps" element={<AdminApps/>} />
    <Route exact path="/privileges/app-modules/:id_app/:slug_name" element={<AdminAppsModule/>} />
    <Route exact path="/privileges/module_menus/:id_module/:slug_name" element={<AdminModuleMenus/>} />
    <Route exact path="/privileges/menus" element={<AdminMenus />} />
    <Route exact path="/privileges/roles" element={<AdminRoles />} />
    <Route exact path="/privileges/roles/:id/:name" element={<AdminRolePermision/>}/>
    <Route exact path="/privileges/modules" element={<AdminModules />} />
    <Route exact path="/privileges/sub-modules/:id/:slug_name" element={<AdminSubModules />} />
    <Route exact path="/privileges/users" element={<AdminUsers/>} />
    <Route exact path="/permissions/:id/:firstname/:lastname" element={<AdminUserPermission/>}/>
    <Route exact path="/change-password" element={<AdminChangePassword/>}/>

    {/* Not Found */}
    {/* <Route exact path="/*" element={<My404Component/>}/> */}

    {/* Page On Dev */}
    <Route exact path="/*" element={<PageOnDev/>}/>

    {/* QR Patrol */}
    <Route exact path="/beranda-patrol" element={<BerandaPatrol/>}/>
    <Route exact path="/check-points" element={<CheckPoint/>}/>
    <Route exact path="/log-check-points" element={<InspectionNotes/>}/>

    {/* Siakad */}
    <Route exact path="/branches" element={<DataCabang/>}/>
    <Route exact path="/schools" element={<DataSekolah/>}/> 
    <Route exact path="/educational-stages" element={<DataJenjang/>}/>
    <Route exact path="/data-siswa" element={<DataMurid/>} />
    <Route exact path="/kelas" element={<DataKelas/>} />
    <Route exact path="/kelas/semester-assignments" element={<ConfigKelas/>} />
    <Route exact path="/semester" element={<DataSemester/>} />
    <Route exact path="/tingkatan" element={<DataTingkatan/>} />
    <Route exact path="/tahun-ajaran" element={<DataTahunAjaran/>} />
    <Route exact path="/matpels" element={<DataMatpel/>}/>
    <Route exact path="/matpels/tipe-ujian" element={<TipeUjian />}/>
    <Route exact path="/matpels/fase" element={<Fase />}/>
    <Route exact path="/matpels/fase/grade/:id/:slug_name" element={<FaseGrade />}/>
    <Route exact path="/matpels/config-matpels" element={<ConfigMatpel />}/>
    <Route exact path="/ekskuls" element={<DataEkskul/>}/>
    <Route exact path="/ekskuls/predikat" element={<PredikatEkskul/>}/>
    <Route exact path="/ekskuls/config-ekskul" element={<ConfigEkskul/>}/>
    <Route exact path="/ekstrakurikuler-assignments" element={<EkskulGuru/>}/>
    <Route exact path="/kalender-akademik" element={<DataKalender/>}/>
    <Route exact path="/kalender-akademik/events" element={<DataEvent />} />
    <Route exact path="/absensi" element={<Absensi/>} />
    <Route exact path="/absensi-admin" element={<AbsensiAdmin/>} />
    <Route exact path="/absen-dashboards-teacher" element={<AbsenDashboardTeacher />}/>
    <Route exact path="/absen-dashboards-head" element={<AbsenDashboardHead />}/>
    <Route exact path="/absen-dashboards" element={<AbsenDashboard />}/>
    <Route exact path="/wali-kelas-" element={<WaliKelas />}/>
    <Route exact path="/wali-kelas" element={<WaliKelasSingle />}/>
    <Route exact path="/matpel-assignments" element={<MatpelGuruYes />}/>
    <Route exact path="/book-scores" element={<BukuNilai />}/>
    <Route exact path="/book-exam-scores" element={<BukuNilaiTeacher />}/>
    <Route exact path="/book-exam-score-recaps" element={<TranskipNilaiTeacher />}/>
    <Route exact path="/book-score-recaps" element={<TranskipNilai />}/>
    <Route exact path="/kegiatan-kokurikuler" element={<KegiatanKokurikuler />}/>
    <Route exact path="/leger-siakad" element={<LegerSiakad />}/>
    <Route exact path="/leger-siakad/type-leger" element={<TypeLeger />}/>
    <Route exact path="/leger-siakad/standar-calculation" element={<AturBobot />}/>
    <Route exact path="/leger-siakad-teacher" element={<LegerSiakadTeacher />}/>
    <Route exact path="/rombel" element={<Rombel />}/>
    <Route exact path="/data-siswa/config-siswa" element={<ConfigSiswaBaru />}/>
    <Route exact path="/rapor-siakad" element={<RaporSiakad />}/>
    <Route exact path="/rapot-siakad-teacher" element={<RaporSiakadTeacher />}/>
    <Route exact path="/rapor-siakad/kategori-komentar" element={<KategoriKomentarSiakad />}/>


    {/* Laporan Adab */}
    <Route exact path="/elements" element={<MasterElements/>}/>
    <Route exact path="/elements/sub-elements/:id_element/:slug_name" element={<MasterSubElements/>} />
    <Route exact path="/kkca" element={<MasterKKCA/>} />
    <Route exact path="/data-dimensi" element={<MasterDimensi/>}/>
    <Route exact path="/beranda-laporan-adab" element={<BerandaLA/>} />
    <Route exact path="/identitas-murid" element={<IdentitasMurid/>} />
    <Route exact path="/element-recaps-dimensi" element={<Penilaian/>} />
    <Route exact path="/element-recaps-dimensi/head" element={<PenilaianHeadSuper/>} />
    <Route exact path="/element-recaps-dimensi/recaps-head-new" element={<PenilaianHeadSuperNew/>} />
    <Route exact path="/element-recaps-dimensi/dimensi-configs" element={<PengaturanDimensi/>} />
    <Route exact path="/element-recaps-dimensi/dimensi-config-heads-new" element={<PengaturanDimensiHeadNew/>} />
    <Route exact path="/element-recaps-dimensi/config-list-dimensi" element={<PengaturanDimensiConfig/>} />
    <Route exact path="/element-recap-head-values" element={<PenilaianHead/>} /> 
    <Route exact path="/recaps-head" element={<PenilaianHeadNew/>} />
    <Route exact path="/element-recaps-dimensi-teacher" element={<PenilaianTeacher/>} />
    <Route exact path="/leger-recaps" element={<Leger/>} />
    <Route exact path="/leger-main" element={<LegerSync/>} />
    <Route exact path="/leger-recaps-head" element={<LegerHead/>} />
    <Route exact path="/leger-head" element={<LegerSyncHead/>} />
    <Route exact path="/leger-recaps-teacher" element={<LegerTeacher/>} />
    <Route exact path="/leger-teacher" element={<LegerSyncTeacher/>} />
    <Route exact path="/element-recaps-rapot" element={<Rapor/>} />
    <Route exact path="/rapot-main" element={<RaporSync/>} />
    <Route exact path="/element-recaps-rapot-head" element={<RaporHead/>} />
    <Route exact path="/rapot-head" element={<RaporHeadSync/>} /> 
    <Route exact path="/element-recaps-rapot-teacher" element={<RaporTeacher/>} />
    <Route exact path="/rapot-teacher" element={<RaporTeacherSync/>} />
    <Route exact path="/dimensi-config-heads" element={<PengaturanDimensiHead/>} />
    <Route exact path="/dashboards-teacher" element={<DashboardTeacher />} />
    <Route exact path="/dashboards-head" element={<DashboardHead />} />
    <Route exact path="/dashboards-main" element={<DashboardSuper />} />
    <Route exact path="/konfigurasi-angket" element={<KonfigurasiAngket />} />
    <Route exact path="/konfigurasi-angket/config-peers-super" element={<ConfigRekan />} /> 
    <Route exact path="/konfigurasi-angket/config-auth-students-super" element={<KonfigurasiAuth/>} />
    <Route exact path="/konfigurasi-angket-teacher" element={<KonfigurasiAngketTeacher />} /> 
    <Route exact path="/konfigurasi-angket-teacher/config-peers" element={<PeerTeacher/>} />
    <Route exact path="/konfigurasi-angket-teacher/config-auth-students" element={<KonfigurasiAuthTeacher/>} />
    <Route exact path="/angket-employees" element={<PenilaianKaryawan/>} />
    <Route exact path="/angket-employees/config-anomalys" element={<ListPrilaku/>} />
    <Route exact path="/categories-penilai" element={<KategoriPenilai/>} />

  </Routes>
  </>
  )
}


function Layout() {
  const isTabletOrMobile = useMediaQuery({
    query: "(max-width: 780px)",
  });

  return (
    <div className="sims-admin-layout">
      {isTabletOrMobile ? (
        <>
          <NavbarMobile />

          <main className="sims-admin-main sims-admin-main--mobile">
            <Content />
          </main>
        </>
      ) : (
        <>
          <Sidebar />

          <main className="sims-admin-main">
            <NavbarDekstop />

            <Content />
          </main>
        </>
      )}
    </div>
  );
}

export default App;
